// Please add new couseTool based on title alphabet arrangement

export type CourseToolId =
  | 'net'
  | 'ai'
  | 'angular'
  | 'apa'
  | 'apspark'
  | 'assembly'
  | 'atl'
  | 'aws'
  | 'aws-sagemaker'
  | 'aws-lambda'
  | 'aws-s3'
  | 'aws-ec2'
  | 'aws-cloudwatch'
  | 'aws-rds'
  | 'aws-iam'
  | 'aws-vpc'
  | 'aws-cf'
  | 'aws-elb'
  | 'azure'
  | 'bash'
  | 'basic'
  | 'bitcoin'
  | 'blockchain'
  | 'bootstrap'
  | 'c'
  | 'cplusplus'
  | 'csharp'
  | 'cloud'
  | 'vr'
  | 'cor'
  | 'css'
  | 'django'
  | 'docker'
  | 'emb'
  | 'ethereum'
  | 'express'
  | 'figma'
  | 'fbase'
  | 'git'
  | 'github'
  | 'gitlab'
  | 'go'
  | 'googleanalytics'
  | 'googlebq'
  | 'googlecloud'
  | 'googlecolab'
  | 'googlesheets'
  | 'gc-ce'
  | 'gc-cs'
  | 'gc-iam'
  | 'gc-vpc'
  | 'gc-sql'
  | 'gc-kub'
  | 'g-c'
  | 'g-cshell'
  | 'g-csdk'
  | 'gc-df'
  | 'gc-dp'
  | 'gc-ps'
  | 'gc-cc'
  | 'gc-ca'
  | 'gc-cal'
  | 'gc-kms'
  | 'gc-scc'
  | 'had'
  | 'hib'
  | 'html'
  | 'hubspot'
  | 'iot'
  | 'java'
  | 'javascript'
  | 'jenk'
  | 'jira'
  | 'jq'
  | 'jupyter'
  | 'kotlin'
  | 'linux'
  | 'matlab'
  | 'matplotlib'
  | 'mysql'
  | 'nbeans'
  | 'next'
  | 'node'
  | 'numpy'
  | 'pandas'
  | 'perl'
  | 'php'
  | 'pman'
  | 'powerbi'
  | 'python'
  | 'pytorch'
  | 'react'
  | 'ruby'
  | 'rust'
  | 'scala'
  | 'scikitlearn'
  | 'scipy'
  | 'seaborn'
  | 'semrush'
  | 'spark'
  | 'spring'
  | 'sql'
  | 'sqlite'
  | 'swift'
  | 'tableau'
  | 'tailwind'
  | 'tensorflow'
  | 'typescript'
  | 'vue'
  | 'web3'
  | 'xam'

export const courseTools: {
  title: string
  id: CourseToolId
  skill: boolean
}[] = [
  {
    title: '.NET',
    id: 'net',
    skill: true
  },
  {
    title: 'AI',
    id: 'ai',
    skill: false
  },
  {
    title: 'Angular',
    id: 'angular',
    skill: true
  },
  {
    title: 'Apache',
    id: 'apa',
    skill: true
  },
  {
    title: 'Apache Spark',
    id: 'apspark',
    skill: true
  },
  {
    title: 'Assembly',
    id: 'assembly',
    skill: true
  },
  {
    title: 'Atlassian',
    id: 'atl',
    skill: true
  },
  {
    title: 'AWS',
    id: 'aws',
    skill: true
  },
  {
    title: 'AWS EC2',
    id: 'aws-ec2',
    skill: true
  },
  {
    title: 'AWS RDS',
    id: 'aws-rds',
    skill: true
  },
  {
    title: 'AWS CloudFormation',
    id: 'aws-cf',
    skill: true
  },
  {
    title: 'AWS Elastic Load Balancing (ELB)',
    id: 'aws-elb',
    skill: true
  },
  {
    title: 'AWS IAM',
    id: 'aws-iam',
    skill: true
  },
  {
    title: 'AWS VPC',
    id: 'aws-vpc',
    skill: true
  },
  {
    title: 'AWS Lambda',
    id: 'aws-lambda',
    skill: true
  },
  {
    title: 'AWS Sagemaker',
    id: 'aws-sagemaker',
    skill: true
  },
  {
    title: 'AWS S3',
    id: 'aws-s3',
    skill: true
  },
  {
    title: 'AWS Cloudwatch',
    id: 'aws-cloudwatch',
    skill: true
  },
  {
    title: 'Azure',
    id: 'azure',
    skill: true
  },
  {
    title: 'Bash',
    id: 'bash',
    skill: true
  },
  {
    title: 'BASIC',
    id: 'basic',
    skill: true
  },
  {
    title: 'Bitcoin',
    id: 'bitcoin',
    skill: false
  },
  {
    title: 'Blockchain',
    id: 'blockchain',
    skill: false
  },
  {
    title: 'Bootstrap',
    id: 'bootstrap',
    skill: true
  },
  {
    title: 'C',
    id: 'c',
    skill: true
  },
  {
    title: 'C++',
    id: 'cplusplus',
    skill: true
  },
  {
    title: 'C#',
    id: 'csharp',
    skill: true
  },
  {
    title: 'Cloud Computing',
    id: 'cloud',
    skill: false
  },
  {
    title: 'Constructed reality',
    id: 'vr',
    skill: false
  },
  {
    title: 'Cordova',
    id: 'cor',
    skill: true
  },
  {
    title: 'CSS',
    id: 'css',
    skill: true
  },
  {
    title: 'Django',
    id: 'django',
    skill: true
  },
  {
    title: 'Docker',
    id: 'docker',
    skill: true
  },
  {
    title: 'EmberJS',
    id: 'emb',
    skill: true
  },
  {
    title: 'Ethereum',
    id: 'ethereum',
    skill: true
  },
  {
    title: 'Express',
    id: 'express',
    skill: true
  },
  {
    title: 'Figma',
    id: 'figma',
    skill: true
  },
  {
    title: 'Firebase',
    id: 'fbase',
    skill: true
  },
  {
    title: 'Git',
    id: 'git',
    skill: true
  },
  {
    title: 'Github',
    id: 'github',
    skill: true
  },
  {
    title: 'GitLab',
    id: 'gitlab',
    skill: true
  },
  {
    title: 'Go (Golang)',
    id: 'go',
    skill: true
  },
  {
    title: 'Google Analytics',
    id: 'googleanalytics',
    skill: true
  },
  {
    title: 'Google BigQuery',
    id: 'googlebq',
    skill: true
  },
  {
    title: 'Google Cloud',
    id: 'googlecloud',
    skill: true
  },
  {
    title: 'Google Colab',
    id: 'googlecolab',
    skill: true
  },
  {
    title: 'Google Cloud Console',
    id: 'g-c',
    skill: true
  },
  {
    title: 'Google Cloud SDK',
    id: 'g-csdk',
    skill: true
  },
  {
    title: 'Google Cloud Shell',
    id: 'g-cshell',
    skill: true
  },
  {
    title: 'Google Cloud VPC',
    id: 'gc-vpc',
    skill: true
  },
  {
    title: 'Google Cloud Storage',
    id: 'gc-cs',
    skill: true
  },
  {
    title: 'Google Compute Engine',
    id: 'gc-ce',
    skill: true
  },
  {
    title: 'Google IAM',
    id: 'gc-iam',
    skill: true
  },
  {
    title: 'Google Sheets',
    id: 'googlesheets',
    skill: true
  },
  {
    title: 'Google Cloud SQL',
    id: 'gc-sql',
    skill: true
  },
  {
    title: 'Google Cloud Kubernetes Engine',
    id: 'gc-kub',
    skill: true
  },
  {
    title: 'Google Cloud Dataflow',
    id: 'gc-df',
    skill: true
  },
  {
    title: 'Google Cloud Dataproc',
    id: 'gc-dp',
    skill: true
  },
  {
    title: 'Google Cloud Pub/Sub',
    id: 'gc-ps',
    skill: true
  },
  {
    title: 'Google Cloud Composer',
    id: 'gc-cc',
    skill: true
  },
  {
    title: 'Google Cloud Armor',
    id: 'gc-ca',
    skill: true
  },
  {
    title: 'Google Cloud Audit Logs',
    id: 'gc-cal',
    skill: true
  },
  {
    title: 'Google Cloud KMS',
    id: 'gc-kms',
    skill: true
  },
  {
    title: 'Google Security Command Center',
    id: 'gc-scc',
    skill: true
  },
  {
    title: 'Hadoop',
    id: 'had',
    skill: true
  },
  {
    title: 'Hibernate',
    id: 'hib',
    skill: true
  },
  {
    title: 'HTML',
    id: 'html',
    skill: true
  },
  {
    title: 'Hubspot',
    id: 'hubspot',
    skill: true
  },
  {
    title: 'Internet of Things',
    id: 'iot',
    skill: false
  },
  {
    title: 'Java',
    id: 'java',
    skill: true
  },
  {
    title: 'Javascript',
    id: 'javascript',
    skill: true
  },
  {
    title: 'Jenkins',
    id: 'jenk',
    skill: true
  },
  {
    title: 'JIRA',
    id: 'jira',
    skill: true
  },
  {
    title: 'jQuery',
    id: 'jq',
    skill: true
  },
  {
    title: 'Jupyter Notebook',
    id: 'jupyter',
    skill: true
  },
  {
    title: 'Kotlin',
    id: 'kotlin',
    skill: true
  },
  {
    title: 'Linux',
    id: 'linux',
    skill: true
  },
  {
    title: 'MATLAB',
    id: 'matlab',
    skill: true
  },
  {
    title: 'Matplotlib',
    id: 'matplotlib',
    skill: true
  },
  {
    title: 'MySQL',
    id: 'mysql',
    skill: true
  },
  {
    title: 'NetBeans',
    id: 'nbeans',
    skill: true
  },
  {
    title: 'Next',
    id: 'next',
    skill: true
  },
  {
    title: 'NodeJS',
    id: 'node',
    skill: true
  },
  {
    title: 'Numpy',
    id: 'numpy',
    skill: true
  },
  {
    title: 'Pandas',
    id: 'pandas',
    skill: true
  },
  {
    title: 'Perl',
    id: 'perl',
    skill: true
  },
  {
    title: 'PHP',
    id: 'php',
    skill: true
  },
  {
    title: 'Postman',
    id: 'pman',
    skill: true
  },
  {
    title: 'Power BI',
    id: 'powerbi',
    skill: true
  },
  {
    title: 'Python',
    id: 'python',
    skill: true
  },
  {
    title: 'Pytorch',
    id: 'pytorch',
    skill: true
  },
  {
    title: 'React',
    id: 'react',
    skill: true
  },
  {
    title: 'Ruby',
    id: 'ruby',
    skill: true
  },
  {
    title: 'Rust',
    id: 'rust',
    skill: true
  },
  {
    title: 'Scala',
    id: 'scala',
    skill: true
  },
  {
    title: 'Scikit-learn',
    id: 'scikitlearn',
    skill: true
  },
  {
    title: 'SciPy',
    id: 'scipy',
    skill: true
  },
  {
    title: 'Seaborn',
    id: 'seaborn',
    skill: true
  },
  {
    title: 'SEMRush',
    id: 'semrush',
    skill: true
  },
  {
    title: 'Spark',
    id: 'spark',
    skill: true
  },
  {
    title: 'Spring',
    id: 'spring',
    skill: true
  },
  {
    title: 'SQL',
    id: 'sql',
    skill: true
  },
  {
    title: 'SQLite',
    id: 'sqlite',
    skill: true
  },
  {
    title: 'Swift',
    id: 'swift',
    skill: true
  },
  {
    title: 'Tableau',
    id: 'tableau',
    skill: true
  },
  {
    title: 'Tailwind CSS',
    id: 'tailwind',
    skill: true
  },
  {
    title: 'TensorFlow',
    id: 'tensorflow',
    skill: true
  },
  {
    title: 'Typescript',
    id: 'typescript',
    skill: true
  },
  {
    title: 'Vue',
    id: 'vue',
    skill: true
  },
  {
    title: 'Web3',
    id: 'web3',
    skill: false
  },
  {
    title: 'Xamarin',
    id: 'xam',
    skill: true
  }
]
